export const PREDICTIONS = [
  {
    boldText: 'В 2026 году вы станете не просто хостом,',
    text: ' а человеком, к которому гости будут возвращаться снова и снова за комфортом, вниманием и ощущением домашнего уюта.',
  },
  {
    boldText: 'Новый год принесёт вам расширение круга постоянных гостей:',
    text: ' больше броней, больше отзывов и больше путешественников, которые с уверенностью выбирают именно вас.',
  },
  {
    boldText: '2026 год научит вас радоваться не только результату, но и процессу,',
    text: ' ведь каждый шаг будет приносить вам удовлетворение и чувство, что вы находитесь на своём месте.',
  },
  {
    boldText: 'В следующем году вы увидите, как ваши объекты становятся частью важных моментов в жизни гостей',
    text: ' и будете гордиться тем, что ваш сервис создаёт для них впечатления.',
  },
  {
    boldText: '2026 год откроет новые направления,',
    text: ' и вы будете чувствовать, что растёте и развиваетесь вместе с рынком посуточной аренды, который никогда не стоит на месте.',
  },
  {
    boldText: 'Вас ждут гости, которые будут искренне благодарны',
    text: ' за комфорт, внимание и заботу, которые вы вкладываете в каждое заселение.',
  },
  {
    boldText: 'Вас ждут отзывы благодарных гостей,',
    text: ' которые будут рады проживанию в вашем объекте.',
  },
  {
    boldText: 'Ваши гости будут рады,',
    text: ' что именно с вами они нашли свой уютный дом вдали от дома.',
  },
  {
    boldText: 'В следующем году вы почувствуете силу комьюнити:',
    text: ' поддержку коллег, обмен опытом и слова благодарности от тех, кому помогли сделать их бизнес лучше.',
  },
  {
    boldText: 'Год принесёт вам больше уверенности:',
    text: ' вы будете всё чаще видеть, что гости выбирают именно вас — потому что доверяют вашему сервису.',
  },
  {
    boldText: 'Новый год подарит много тёплых встреч',
    text: ' — с гостями, которые не просто довольны, а искренне рады, что остановились именно у вас.',
  },
];
